import { Star, Quote } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Alex Chen",
      role: "Tech YouTuber • 500K Subscribers",
      avatar: "AC",
      content: "ThumbGenius completely transformed my channel. My CTR went from 4% to 11% in just two months. The AI understands what makes thumbnails click-worthy.",
      rating: 5,
    },
    {
      name: "Sarah Martinez",
      role: "Lifestyle Vlogger • 250K Subscribers",
      avatar: "SM",
      content: "I used to spend hours on Photoshop for each thumbnail. Now I generate 10 options in 30 seconds and they all look professional. Game changer!",
      rating: 5,
    },
    {
      name: "Marcus Johnson",
      role: "Gaming Channel • 1.2M Subscribers",
      avatar: "MJ",
      content: "The AI knows exactly what my audience wants to see. My views doubled since I started using ThumbGenius. Best investment I've made for my channel.",
      rating: 5,
    },
    {
      name: "Emily Wong",
      role: "Business Coach • 180K Subscribers",
      avatar: "EW",
      content: "Professional thumbnails without the professional price. My small business clients love the results. Worth every penny of the Pro subscription.",
      rating: 5,
    },
    {
      name: "David Kim",
      role: "Fitness Influencer • 750K Subscribers",
      avatar: "DK",
      content: "The emotion detection is incredible. It knows exactly how to make my transformation videos pop. My audience engagement has never been higher.",
      rating: 5,
    },
    {
      name: "Rachel Brown",
      role: "Educational Content • 400K Subscribers",
      avatar: "RB",
      content: "Finally, a tool that understands educational content. The AI generates thumbnails that are informative yet eye-catching. My students love them!",
      rating: 5,
    },
  ];

  return (
    <section className="section-padding relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-secondary/10 to-background" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-brand-purple/10 rounded-full blur-3xl" />

      <div className="container-custom relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-semibold text-brand-cyan uppercase tracking-wider mb-4 block">
            Testimonials
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Loved by{" "}
            <span className="gradient-text">10,000+ Creators</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Don't just take our word for it. Here's what our community has to say.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="relative p-6 rounded-2xl bg-card border border-border hover:border-primary/30 transition-all duration-300 group"
            >
              {/* Quote Icon */}
              <Quote className="absolute top-6 right-6 w-8 h-8 text-primary/20 group-hover:text-primary/40 transition-colors" />

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-500 text-yellow-500" />
                ))}
              </div>

              {/* Content */}
              <p className="text-foreground/90 mb-6 leading-relaxed">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full gradient-bg flex items-center justify-center text-primary-foreground font-semibold">
                  {testimonial.avatar}
                </div>
                <div>
                  <h4 className="font-semibold">{testimonial.name}</h4>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Social Proof Stats */}
        <div className="mt-16 p-8 rounded-2xl bg-card border border-border">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { value: "50,000+", label: "Thumbnails Generated" },
              { value: "10,000+", label: "Happy Creators" },
              { value: "4.9/5", label: "Average Rating" },
              { value: "2.5x", label: "Avg CTR Increase" },
            ].map((stat, index) => (
              <div key={index}>
                <div className="text-2xl md:text-3xl font-bold gradient-text mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-muted-foreground">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
